import { AddressDisplaySmall } from './AddressDisplay';
import ContactInformationSimple from './ContactInformationSimple';
import { useAddressContactSectionStyles } from './AddressContactSection.styles';

export default function AddressContactSection({
  address,
  companyName,
  contact,
}) {
  const { styles } = useAddressContactSectionStyles();
  return (
    <div className={styles.flightInfoSection}>
      {companyName && <p>{companyName}</p>}
      <ContactInformationSimple contact={contact} />
      {address && <AddressDisplaySmall address={address} />}
    </div>
  );
}
